<template>
  <div class="monitor">
    <div class="title">
      <!-- v-if="/home/monitor" -->
      <el-breadcrumb >
        <el-breadcrumb-item>价格监测</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
   
    <div class="main"
     v-if="service_status==1"
        >
      <el-card>
        <el-form :inline="true"
                 :model="formInline"
                 class="demo-form-inline">
          <div>
            <el-form-item label="授权类型："
                          v-show="activeName == 'second'">
              <el-select v-model="formInline.is_auth"
                         placeholder="请选择授权类型"
                         clearable>
                <el-option label="授权"
                           :value="1"> </el-option>
                <el-option label="未授权"
                           :value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台："
                          v-show="activeName == 'second'">
              <el-select v-model="formInline.platform_id"
                         placeholder="请选择平台"
                         clearable>
                <el-option v-for="item in options"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="方案名称：">
              <el-input v-model="formInline.name"
                        placeholder="请输入方案名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="reset"
                         v-if="service_status !==0">重 置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         v-if="service_status !==0"
                         @click="onSubmit">查 询</el-button>
            </el-form-item>
          </div>
          <el-form-item v-if="service_list.length>0">
            <el-button type="primary"
                       v-if="activeName == 'product'"
                       @click="operate('product', 'add')">新增检测计划</el-button>
            <el-button type="primary"
                       v-if="activeName == 'sku'"
                       @click="operate('sku', 'add')">新增检测计划</el-button>
            <el-button type="primary"
                       @click="operate('shop', 'add')"
                       v-if="activeName == 'shop'">新增店铺</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane :label="item.name"
                       v-for="item in service_list"
                       :key="item.code"
                       :name="item.code"></el-tab-pane>
          <!--     <el-tab-pane label="SKU检测"
                       name="sku"></el-tab-pane>
          <el-tab-pane label="授权店铺"
                       name="shop"></el-tab-pane> -->
        </el-tabs>
        <div class="table">
          <!-- 产品检测 -->
          <el-table :data="tableData"
                    style="width: 100%"
                    border
                    v-loading="load"
                    v-if="activeName == 'product'">
            <el-table-column align="center"
                             prop="name"
                             label="检测方案名称"> </el-table-column>
            <el-table-column align="center"
                             prop="platform_name"
                             label="平台">
              <template slot-scope="{ row }">
                {{ row.platform_name || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="run_type"
                             label="类型">
              <template slot-scope="{ row }">
                {{ run_type_opt[Number(row.run_type) - 1] }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="sku_total"
                             sortable
                             label="全部SKU数"> </el-table-column>
            <el-table-column align="center"
                             prop="update_time"
                             label="更新时间"> </el-table-column>
            <el-table-column align="center"
                             prop="status"
                             label="状态">
              <template slot-scope="{ row }"> <span :class="row.status == 1 ? 'dot1' : 'dot'"></span> {{ status_opt[Number(row.status) - 1] }} </template>
            </el-table-column>
            <el-table-column align="center"
                             label="操作">
              <template slot-scope="{ row }">
                <div class="link">
                  <el-link type="primary"
                           @click="operate('product', 'edit', row.id)">修改</el-link>
                  <el-link type="primary"
                           @click="operate('product', 'delete', row.id)">删除</el-link>
                  <el-link type="primary"
                           @click="operate('product', 'detail', row.id,row.name)">详情</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- SKU检测 -->
          <el-table :data="tableData"
                    style="width: 100%"
                    border
                    v-loading="load"
                    v-if="activeName == 'sku'">
            <el-table-column align="center"
                             prop="name"
                             label="检测方案名称"> </el-table-column>
            <el-table-column align="center"
                             prop="sku_total"
                             sortable
                             label="全部SKU数"> </el-table-column>
            <el-table-column align="center"
                             prop="update_time"
                             label="更新时间"> </el-table-column>
            <el-table-column align="center"
                             prop="status"
                             label="状态">
              <template slot-scope="{ row }"> <span :class="row.status == 1 ? 'dot1' : 'dot'"></span> {{ status_opt[Number(row.status) - 1] }} </template>
            </el-table-column>
            <el-table-column align="center"
                             label="操作">
              <template slot-scope="{ row }">
                <div class="link">
                  <el-link type="primary"
                           @click="operate('sku', 'edit', row.id)">修改</el-link>
                  <el-link type="primary"
                           @click="operate('sku', 'delete', row.id)">删除</el-link>
                  <el-link type="primary"
                           @click="operate('sku', 'detail', row.id,row.name)">详情</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 店铺检测 -->
          <el-table :data="tableData"
                    style="width: 100%"
                    border
                    v-loading="load"
                    v-if="activeName == 'shop'">
            <el-table-column align="center"
                             prop="id"
                             label="ID"> </el-table-column>
            <el-table-column align="center"
                             prop="name"
                             label="店铺名称">
              <template slot-scope="{ row }">
                {{ row.name || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="is_auth"
                             label="是否授权">
              <template slot-scope="{ row }">
                {{ row.is_auth == 1 ? "已授权" : "未授权" }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="platform"
                             label="平台">
              <template slot-scope="{ row }"> {{ row.platform }} </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="shopProductNum"
                             label="商品数量"
                             sortable> </el-table-column>
            <el-table-column align="center"
                             label="操作">
              <template slot-scope="{ row }">
                <div class="link">
                  <el-link type="primary"
                           @click="operate('shop', 'edit', row.id)">修改</el-link>
                  <el-link type="primary"
                           @click="operate('shop', 'delete', row.id)">删除</el-link>
                  <el-link type="primary"
                           @click="operate('shop', 'detail', row.id,row.name)">详情</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
     <div class="main-one"
         v-else   v-loading="loading"   element-loading-background="rgba(255, 255, 255,1)">
      <p  v-if="service_status==0&&loading==false"> 暂无购买价格检测的套餐，请去购买</p>
      <div class="int-btn">
        <el-button type="primary"   v-if="service_status==0&&loading==false" 
                   @click="handleClickBuy">去购买</el-button>
      </div>
    </div>
    <CreateOrEditPlan ref="refCreateOrEditPlan"
                      @init="getList(1)"
                      :type="type"></CreateOrEditPlan>
    <CreateOrEditShop ref="refCreateOrEditShop"
                      @init="getList(1)"
                      :type="type"></CreateOrEditShop>
  </div>
</template>

<script>
import CreateOrEditPlan from "@/components/Modules/Monitor/CreateOrEditPlan.vue";
import CreateOrEditShop from "@/components/Modules/Monitor/CreateOrEditShop.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      run_type_opt: ["即时监控", "定时监控"],
      status_opt: ["进行中", "等待中", "已关闭"],
      total: 0,
      page: 1,
      size: 10,
      load: false,
      formInline: {
        name: "",
        is_auth: "",
        platform_id: "",
      },
      loading:false,
      activeName: '',
      options: [],
      tableData: [],
      type: "", //产品检测/sku检测
      service_status: '',
      service_list: []
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  components: {
    CreateOrEditPlan,
    CreateOrEditShop,
  },
  async created () {
/*     if (sessionStorage.getItem('type')) {
      this.activeName = sessionStorage.getItem('type')
    } */
      this.getserviceShow()
    await this.getPlatform();
/*     await this.getList(1); */
  

  },
  methods: {
    ...mapActions({
      consoleplanList: "detect/consoleplanList", //产品列表
      shopIndex: "detect/shopIndex", //店铺列表
      platformSelect: "detect/platformSelect", //平台列表
      consoleplanDelete: "detect/consoleplanDelete", //平台列表
      shopDel: "detect/shopDel",
      serviceShow: "detect/serviceShow",
    }),
    handleClickBuy () {
      this.$router.push('/home/detection')
    },
    getserviceShow () {
      this.loading = true
      let params = {
        token: this.getToken,
      };
      this.serviceShow(params).then(({ data }) => {
        if (data.code == 1) {
          
          this.service_status = data.data.service_status
          if (  this.service_status) {
              this.loading = false
          }
          data.data.service_data.forEach(item => {
            if (item.code == 'PRODUCT_MONITOR') {
              let ong = {
                code: "product",
                name: item.name
              }
              this.service_list.push(ong)
            } else if (item.code == 'SKU_MONITOR') {
              let ong = {
                code: "sku",
                name: item.name
              }
              this.service_list.push(ong)
            } else if (item.code == 'SHOP_MONITOR') {
              let ong = {
                code: "shop",
                name: item.name
              }
              this.service_list.push(ong)
            }
          })
          if (this.service_list.length>0) {
            this.activeName=this.service_list[0].code
          }
           this.loading = false
        console.log(this.service_list,'this.service_list---')
          if (  this.activeName) {
            this.getList(1);
          }
          
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getPlatform () {
      let params = {
        token: this.getToken,
      };
      this.platformSelect(params).then(({ data }) => {
        if (data.code == 1) {
          this.options = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 获取列巴
    getList (tag) {
      this.load = true;
      let params, url;
      if (this.activeName == "product") {
        params = {
          token: this.getToken, //用户token
          name: this.formInline.name, //方案名称 非必填
          plan_type: "1", //检测类型 必填 1 产品检测  2 sku检测
          page: tag == 1 ? tag : this.page, //当前页数
          size: this.size, //每页显示条数
        };
        url = this.consoleplanList;
      } else if (this.activeName == "sku") {
        params = {
          token: this.getToken, //用户token
          name: this.formInline.name, //方案名称 非必填
          plan_type: "2", //检测类型 必填 1 产品检测  2 sku检测
          page: tag == 1 ? tag : this.page, //当前页数
          size: this.size, //每页显示条数
        };
        url = this.consoleplanList;
      } else {
        params = {
          token: this.getToken, //用户token
          name: this.formInline.name, //方案名称 非必填
          is_auth: this.formInline.is_auth,
          platform_id: this.formInline.platform_id,
          page: tag == 1 ? tag : this.page, //当前页数
          size: this.size, //每页显示条数
        };
        url = this.shopIndex;
      }
      url(params).then(({ data }) => {
        this.load = false;
        if (data.code == 1) {
          if (this.activeName == "product" || this.activeName == "sku") {
            this.tableData = data.data.list;
          } else {
            this.tableData = data.data.data;
            if (this.tableData.length > 0) {
              this.tableData.forEach((item) => {
                item.platform = this.options.find((v) => item.platform_id == v.id).name || "-";
              });
            }
          }
          this.total = data.data.count;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 查询
    onSubmit () {
      this.getList();
    },
    operate (type, opt, id, name) {
      sessionStorage.setItem('testname', name)
      switch (type) {
        case "product":
          this.type = type;
          if (opt == "add") {
            this.$refs.refCreateOrEditPlan.dialogVisible = true;
             this.$refs.refCreateOrEditPlan.getplatform()
          } else if (opt == "edit") {
            this.$refs.refCreateOrEditPlan.dialogVisible = true;
            this.$refs.refCreateOrEditPlan.getDetail(id);
            this.$refs.refCreateOrEditPlan.getplatform()
;
          } else if (opt == "detail") {
            sessionStorage.setItem('type', type)
            this.$router.push({
              path: `/home/productMonitor/product/${id}`,
            });
          } else if (opt == "delete") {
            this.deleteItem(id);
          }
          break;
        case "sku":
          this.type = type;
          if (opt == "add") {
            this.$refs.refCreateOrEditPlan.dialogVisible = true;
          } else if (opt == "edit") {
            this.$refs.refCreateOrEditPlan.dialogVisible = true;
            this.$refs.refCreateOrEditPlan.getDetail(id);
          } else if (opt == "detail") {
            sessionStorage.setItem('type', type)
            this.$router.push({
              //  path: `/home/productMonitor/sku/${id}`,
              path: `/home/productMonitorDetail/sku/${id}`,
            });
          } else if (opt == "delete") {
            this.deleteItem(id);
          }
          break;
        case "shop":
          if (opt == "add") {
            this.$refs.refCreateOrEditShop.dialogVisible = true;
          } else if (opt == "edit") {
            this.$refs.refCreateOrEditShop.dialogVisible = true;
            this.$refs.refCreateOrEditShop.edit_id = id;
            this.$refs.refCreateOrEditShop.ruleForm = JSON.parse(JSON.stringify(this.tableData.find((item) => item.id == id)));
          } else if (opt == "detail") {
            sessionStorage.setItem('type', type)
            this.$router.push({
              // path: `/home/productMonitor/shop/${id}`,
              path: `/home/productMonitorDetail/shop/${id}`,
            });
          } else if (opt == "delete") {
            this.deleteShop(id);
          }
          break;
        default:
          break;
      }
    },
    deleteShop (id) {
      this.$confirm("是否确认删除此数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            token: this.getToken,
            id: id,
          };
          this.shopDel(params).then(({ data }) => {
            if (data.code == 1) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteItem (id) {
      this.$confirm("是否确认删除此数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            token: this.getToken,
            id: id,
          };
          this.consoleplanDelete(params).then(({ data }) => {
            if (data.code == 1) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    reset () {
      this.formInline = {
        name: "",
        is_auth: "",
        platform_id: "",
      };
      this.tableData = [];
      this.getList(1);
    },
    handleClick (val) {
      console.log(val,'----')
      this.reset();
    },
    handleSizeChange (val) {
      this.size = val;
    },
    handleCurrentChange (val) {
      this.page = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.monitor {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
  }
  .main-one {
    min-width: 1200px;
    min-height: 600px;
    margin: 20px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    .int-btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      width: 300px;
      ::v-deep .el-button {
        width: 160px;
        height: 32px;
      }
      ::v-deep .el-button--primary {
        color: #fff;
        background-color: #2448ff;
        border-color: #2448ff;
      }
    }
  }
  .main {
    min-width: 1200px;
    margin: 20px;
    .demo-form-inline {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .el-card {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
    ::v-deep .el-form--inline .el-form-item {
      margin: 10px 10px 10px 0;
    }
    .table {
      min-height: 510px;
    }
  }
  .pageSize {
    text-align: right;
    margin-top: 20px;
  }
}
::v-deep .el-table--border th.el-table__cell {
  background-color: #f8f9fe;
}
.link {
  a {
    margin: 0 8px;
  }
}
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f00;
  transform: translateY(-2px);
  margin-right: 4px;
}
.dot1 {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #0094ff;
  transform: translateY(-2px);
  margin-right: 4px;
}
</style>